module.exports = __webpack_public_path__ + "img/daihuankuan.74b6a7e7.png";